export default "__VITE_ASSET__CPDYHx17__"